import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import "react-quill/dist/quill.snow.css";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";
import { disabledFieldSx } from "../../constants/fieldStyles";

const SupplierDetailsModal = ({ supplier, open, onClose }) => {
  return (
    <>
      <Dialog open={open} onClose={onClose}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DialogTitle
            fontSize={"20px"}
            fontFamily={"poppins"}
            fontWeight={500}
            color={"var(--text-primary)"}
          >
            {"Supplier Details"}
          </DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <CustomTypography>Supplier Name</CustomTypography>
              <TextField
                size="small"
                autoFocus
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={supplier?.name || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Email</CustomTypography>
              <TextField
                sx={disabledFieldSx}
                type="email"
                size="small"
                variant="outlined"
                value={supplier?.email}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Address 1</CustomTypography>
              <TextField
                sx={disabledFieldSx}
                type="text"
                size="small"
                variant="outlined"
                value={supplier?.address?.address1}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Address 2</CustomTypography>
              <TextField
                sx={disabledFieldSx}
                type="text"
                size="small"
                variant="outlined"
                value={supplier?.address?.address2}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>City</CustomTypography>
              <TextField
                sx={disabledFieldSx}
                type="text"
                size="small"
                variant="outlined"
                value={supplier?.address?.city}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Zipcode</CustomTypography>
              <TextField
                sx={disabledFieldSx}
                type="text"
                size="small"
                variant="outlined"
                value={supplier?.address?.zipcode}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Province</CustomTypography>
              <TextField
                sx={disabledFieldSx}
                type="text"
                size="small"
                variant="outlined"
                value={supplier?.address?.province}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Province Code</CustomTypography>
              <TextField
                sx={disabledFieldSx}
                type="text"
                size="small"
                variant="outlined"
                value={supplier?.address?.province_code}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Country</CustomTypography>
              <TextField
                sx={disabledFieldSx}
                type="text"
                size="small"
                variant="outlined"
                value={supplier?.address?.country}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <CustomTypography fontSize={15}>Country Code</CustomTypography>
              <TextField
                sx={disabledFieldSx}
                type="text"
                size="small"
                variant="outlined"
                value={supplier?.address?.country_code}
                fullWidth
                autoFocus
                margin="dense"
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions style={{ padding: 10 }}>
          <Button
            onClick={onClose}
            variant="outlined"
            style={{ textTransform: "none" }}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default SupplierDetailsModal;
